'use client';

import { useEffect } from 'react';
import { usePathname } from 'next/navigation';
import { getRuntimeOrg, asset } from '@/utils/runtimeOrg';

type Theme = Record<string, string>;
type ThemePack = { light?: Theme; dark?: Theme };
type Props = {
  name?: string;
  favicon?: string;
  theme?: ThemePack;
  themeMode?: 'light' | 'dark';
};

const ThemeLoader = ({ name, favicon, theme, themeMode = 'light' }: Props) => {
  const pathname = usePathname();

  useEffect(() => {
    const org = getRuntimeOrg();
    const root = document.documentElement;

    root.setAttribute('data-theme', themeMode);

    const colors = (theme?.[themeMode] ?? {}) as Record<string, string>;
    for (const [k, v] of Object.entries(colors)) {
      root.style.setProperty(`--color-${k}`, String(v));
    }

    if (name) document.title = name;

    if (favicon) {
      const href = asset(favicon, org);
      const rels = ['icon', 'shortcut icon', 'apple-touch-icon'];
      for (const rel of rels) {
        let link = document.querySelector<HTMLLinkElement>(
          `link[rel="${rel}"]`
        );
        if (!link) {
          link = document.createElement('link');
          link.rel = rel;
          document.head.appendChild(link);
        }
        link.href = href;
      }
    }
  }, [pathname, name, favicon, theme, themeMode]);

  return null;
};

export default ThemeLoader;
